import { useApiTradeV1TradeCompaniesRetrieve } from 'api';
import { Link, useParams } from 'react-router-dom';
import { CenteredLoader, Page, Section } from 'ui';

import { NewCompanySiteMaterialForm } from '../../components/NewCompanySiteMaterialForm/NewCompanySiteMaterialForm';

export const NewSiteMaterial = () => {
  const { companyId } = useParams();
  const { data: tradeCompany, isLoading } = useApiTradeV1TradeCompaniesRetrieve(Number(companyId));

  if (isLoading || !tradeCompany) {
    return <CenteredLoader />;
  }

  return (
    <Page>
      <Page.BackButton component={Link} to={`/ground-control/v2/manage-company/${companyId}/site-materials`}>
        Back to {tradeCompany.name} site materials
      </Page.BackButton>
      <Page.Title title={`Create new site material for ${tradeCompany.name}`} />
      <Page.Divider />
      <Section>
        <NewCompanySiteMaterialForm companyId={tradeCompany.id} />
      </Section>
    </Page>
  );
};
